import theme from '../../styles/themes/default';

export const selectStyle = {
  indicatorSeparator: (styles: any) => ({
    ...styles,
    display: 'none',
    border: 'none',
  }),
  control: (styles: any, { isFocused }: any) => ({
    ...styles,
    backgroundColor: theme.colors.white,
    width: '100%',
    height: '48px',
    boxShadow: 'none',
    outline: 'none',
    border: '1px solid',
    borderRadius: '8px',
    color: theme.colors.gray[400],
    padding: '0',
    '&:hover': {
      borderColor: theme.colors.orange.primary,
    },
    maxHeight: '48px',
    cursor: 'pointer',
    overflow: 'scroll',
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    margin: '0 16px',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    fontSize: '14px',
    fontFamily: 'Poppins',
    // margin: '0 16px',
    fontWeight: 300,
    color: theme.colors.gray[500],
    whiteSpace: 'nowrap',
  }),
  option: (styles: any, { isFocused }: any) => ({
    ...styles,
    backgroundColor: isFocused ? theme.colors.gray[100] : theme.colors.white,
    color: isFocused ? theme.colors.gray[900] : theme.colors.gray[400],
    fontSize: '14px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: theme.colors.gray[500],
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  }),
  menu: (styles: any) => ({
    ...styles,
    color: theme.colors.gray[600],
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  }),
};
